// Import Libraries
import React from 'react';
import { Grid } from '@mui/material';

// Components
import UserDetails from '../../components/UserComponents/userDetails';
import AboutUs from '../../components/UserComponents/aboutUs';

function UserProfileTab({ useUser, isStaff }) {
  return (
    <>
      {useUser?.id ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <UserDetails userDetails={useUser} />
          </Grid>

          <Grid item xs={12} md={6}>
            <AboutUs userDetails={useUser} />
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}

export default UserProfileTab;
